module.exports = ".banner__img {\n  max-width: 768px;\n  max-height: 258px;\n  background-color: #cccccc; }\n\n.banner__upload-btn {\n  border: 1px solid #ccc;\n  background-color: #bbb;\n  cursor: pointer;\n  padding: 10px;\n  color: #fff; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/banner/shared/banner-form/banner-form.component.scss
// module id = ./src/app/banner/shared/banner-form/banner-form.component.scss
// module chunks = main